import {QueryBuilderColumn, QueryBuilderReducerActionTypeEnum, QueryBuilderReducerDispatch, QueryBuilderStateQueryRule} from "../../../../index";
import React, {FunctionComponent, useCallback} from "react";
import {Box, Checkbox, FormControlLabel} from "@mui/material";

export interface QueryBuilderValueInputCheckboxProps {
    rule: QueryBuilderStateQueryRule;
    ruleIndex: number;
    conditionIndex: number;
    disabled: boolean;
    dispatch: QueryBuilderReducerDispatch;
    column: QueryBuilderColumn;
}

const QueryBuilderValueInputCheckbox: FunctionComponent<QueryBuilderValueInputCheckboxProps> = ({
                                                                                                    column,
                                                                                                    dispatch,
                                                                                                    disabled,
                                                                                                    rule,
                                                                                                    ruleIndex,
                                                                                                    conditionIndex,
                                                                                                }) => {
    /**
     * Commits the rule's value in the reducer for string types.
     */
    const commitCheckboxValue = useCallback((value: boolean) => {
        dispatch({
            type: QueryBuilderReducerActionTypeEnum.ChangeValue,
            payload: {
                conditionIndex: conditionIndex,
                ruleIndex: ruleIndex,
                value: value === rule.value ? undefined : value,
                operator: value === rule.value ? null : "equal",
            },
        })
    }, [dispatch, conditionIndex, ruleIndex, rule.value]);


    return (
        <>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center'}}>
                <FormControlLabel
                    label={column.falseValue ?? "No"}
                    sx={{margin: 0}}
                    control={
                        <Checkbox
                            disabled={disabled}
                            sx={{paddingBlock: 0.75}}
                            disableRipple
                            checked={!(rule.value as boolean ?? true)}
                            // indeterminate={rule.value === undefined}
                            onChange={() => commitCheckboxValue(false)}
                        />
                    }
                />
                <FormControlLabel
                    label={column.trueValue ?? "Yes"}
                    sx={{margin: 0}}
                    control={
                        <Checkbox
                            disabled={disabled}
                            sx={{paddingBlock: 0.75}}
                            disableRipple
                            checked={(rule.value as boolean ?? false)}
                            // indeterminate={rule.value === undefined}
                            onChange={() => commitCheckboxValue(true)}
                        />
                    }
                />
            </Box>
        </>
    );
};
export default QueryBuilderValueInputCheckbox;
